import { MessageType } from '../types/messageTypes'

export const CHAT_ASSISTANT_ID = 'chatbot-id'
export const PRIVACY_POLICY_PAGE_PATHNAME = '/privacy-policy'

export const INDEXED_DB_NAME = 'chatbot'
export const INDEXED_DB_TABLE_NAME = 'conversation'

export const IS_CHAT_OPEN_KEY = 'isChatOpen'
export const IS_CHAT_MINIMIZED_KEY = 'isChatMinimized'
export const IS_MESSAGE_PULLING_LS_ID = 'isChatbotPulling'
export const IS_AGENT_QUEUE_LS_ID = 'isAgentQueue'
export const CHATBOT_SESSION_ID_LS_ID = 'chatbotSessionId'
export const STARTED_QUEUE_TIME_LS_ID = 'startedQueueTime'
export const TAB_ID_LS_ID = 'chatbotTabId'
export const LAST_CHAT_INTERACTION = 'lastChatInteraction'
export const HAS_CHAT_INTERACTION_TIMEOUT = 'hasChatInteractionTimeout'

export const ANALYTICS_LIST_ID = 'fashionAssistant'

export const CHAT_MESSAGE_CHOICES = [
	MessageType.IceBreakers,
	MessageType.IceBreakersNba,
	MessageType.QuickReplies,
	MessageType.OrderList,
	MessageType.LeaveAgentQueue,
	MessageType.WarningAgentQueue,
	MessageType.SearchAddress,
]

export const UNSUPPORTED_LINE_CATEGORY = 'unsupported-line'

export const ABORT_REASON = 'Chat dialog has been closed'

export const NBA_VARIABLE_INDEX = 1
